

import axios from "axios";

// const BASE_URL = "https://esystems.cdl.lk/backend/AttendMe2/attme/";

const TEST_LOGIN_MAP = {
  "94111111111": {
    otpTarget: "0776491208",
    // otpTarget: "0718437221",
    loginAs: "94741100593",
  },
};



export const authenticatePhoneNo = async (phoneNumber) => {
  const headers = {
    UserId: "DTSUSER",
    Password: "Dts@10099",
    PhoneNo: phoneNumber  
  };

  const url = `attme/AuthenticatePhoneNo`;

  try {
    const response = await axios.post(url, {}, { headers });
    return response.data;
  } catch (error) {
    console.error("Error authenticating phone number:", error);
    throw error.response
      ? error.response.data
      : { message: "Server Error. Unable to authenticate phone number." };
  }
};
//workin

// export const verificationCall = async (phoneNumber) => {
//   const headers = {
//     UserId: "DTSUSER",
//     Password: "Dts@10099",
//     "Content-Type": "application/json",
//   };

  
//   const plainPhoneNumber = phoneNumber.replace("+", "");

//   const url = `attme/VerificationCall`;
//   const body = { MobileNumber: plainPhoneNumber };

//   try {
//     const response = await axios.post(url, body, { headers });
//     return response.data;
//   } catch (error) {
//     console.error("Error sending verification call:", error);
//     throw error.response
//       ? error.response.data
//       : { message: "Server Error. Unable to send verification call." };
//   }
// };

export const verificationCall = async (phoneNumber) => {
  const headers = {
    UserId: "DTSUSER",
    Password: "Dts@10099",
    "Content-Type": "application/json",
  };

  const normalized = String(phoneNumber).replace(/[^0-9]/g, "");

  let otpNumber = phoneNumber;

  // 🔹 Test number handling (FIXED)
  if (TEST_LOGIN_MAP[normalized]) {
    otpNumber = TEST_LOGIN_MAP[normalized].otpTarget;
  }

  const plainPhoneNumber = otpNumber.replace(/[^0-9]/g, "");

  const url = `attme/VerificationCall`;
  const body = { MobileNumber: plainPhoneNumber };

  console.log("OTP SENT TO 👉", plainPhoneNumber); // 🔍 debug

  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error sending verification call:", error);
    throw error.response
      ? error.response.data
      : { message: "Server Error. Unable to send verification call." };
  }
};


// workin
// export const fetchUserData = async (phoneNumber) => {
//   const headers = {
//       UserId: "DTSUSER",
//       Password: "Dts@10099",
//   };

  

//   // Clean the phone number
//   const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
  
//   // Create both formats
//   let withPlus = cleanNumber;
//   let withoutPlus = cleanNumber;

//   // Format the numbers correctly
//   if (cleanNumber.startsWith('94')) {
//       withPlus = `+${cleanNumber}`;
//       withoutPlus = cleanNumber;
//   } else if (cleanNumber.startsWith('+94')) {
//       withPlus = cleanNumber;
//       withoutPlus = cleanNumber.slice(1);
//   }

//   const tryFormat = async (number) => {
//       try {
//           headers.PhoneNo = number;
//           const response = await axios.get(
//               `attme/Login`,
//               { headers }
//           );
          
//           // Check both responceType and responceMessage
//           if (response?.data?.responceType === true && response?.data?.responceMessage) {
//               return {
//                   success: true,
//                   data: response.data,
//                   phoneFormat: number
//               };
//           }
//           return { success: false };
//       } catch (error) {
//           console.log(`Failed with format ${number}:`, error);
//           return { success: false };
//       }
//   };

//   try {
//       // Try both formats sequentially to ensure proper handling
//       const plusResult = await tryFormat(withPlus);
//       if (plusResult.success) {
//           return {
//               ...plusResult.data,
//               correctPhoneFormat: withPlus,
//               headers: { ...headers, PhoneNo: withPlus }
//           };
//       }

//       const noPlusResult = await tryFormat(withoutPlus);
//       if (noPlusResult.success) {
//           return {
//               ...noPlusResult.data,
//               correctPhoneFormat: withPlus, // Always store as +94 format
//               headers: { ...headers, PhoneNo: withPlus }
//           };
//       }

//       throw new Error("Neither phone format was accepted");
//   } catch (error) {
//       console.error("Error fetching user data:", error);
//       throw error.response
//           ? error.response.data
//           : { message: "Server Error. Unable to fetch user data." };
//   }
// };

export const fetchUserData = async (phoneNumber) => {
  const headers = {
      UserId: "DTSUSER",
      Password: "Dts@10099",
  }; 

  const normalized = String(phoneNumber).replace(/[^0-9]/g, "");

  if (TEST_LOGIN_MAP[normalized]) {
    phoneNumber = TEST_LOGIN_MAP[normalized].loginAs;
  }
  // Clean the phone number
  const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
  
  // Create both formats
  let withPlus = cleanNumber;
  let withoutPlus = cleanNumber;

  // Format the numbers correctly
  if (cleanNumber.startsWith('94')) {
      withPlus = `+${cleanNumber}`;
      withoutPlus = cleanNumber;
  } else if (cleanNumber.startsWith('+94')) {
      withPlus = cleanNumber;
      withoutPlus = cleanNumber.slice(1);
  }

  const tryFormat = async (number) => {
      try {
          headers.PhoneNo = number;
          const response = await axios.get(
              `attme/Login`,
              { headers }
          );
          
          // Check both responceType and responceMessage
          if (response?.data?.responceType === true && response?.data?.responceMessage) {
              return {
                  success: true,
                  data: response.data,
                  phoneFormat: number
              };
          }
          return { success: false };
      } catch (error) {
          console.log(`Failed with format ${number}:`, error);
          return { success: false };
      }
  };

  try {
      // Try both formats sequentially to ensure proper handling
      const plusResult = await tryFormat(withPlus);
      if (plusResult.success) {
          return {
              ...plusResult.data,
              correctPhoneFormat: withPlus,
              headers: { ...headers, PhoneNo: withPlus }
          };
      }

      const noPlusResult = await tryFormat(withoutPlus);
      if (noPlusResult.success) {
          return {
              ...noPlusResult.data,
              correctPhoneFormat: withPlus, // Always store as +94 format
              headers: { ...headers, PhoneNo: withPlus }
          };
      }

      throw new Error("Neither phone format was accepted");
  } catch (error) {
      console.error("Error fetching user data:", error);
      throw error.response
          ? error.response.data
          : { message: "Server Error. Unable to fetch user data." };
  }
};










//--------------------------------------------------Before edit Phone no = 111111111-------------------------------------------------
// import axios from "axios";

// // const BASE_URL = "https://esystems.cdl.lk/backend/AttendMe2/attme/";

// export const authenticatePhoneNo = async (phoneNumber) => {
//   const headers = {
//     UserId: "DTSUSER",
//     Password: "Dts@10099",
//     PhoneNo: phoneNumber  
//   };

//   const url = `attme/AuthenticatePhoneNo`;

//   try {
//     const response = await axios.post(url, {}, { headers });
//     return response.data;
//   } catch (error) {
//     console.error("Error authenticating phone number:", error);
//     throw error.response
//       ? error.response.data
//       : { message: "Server Error. Unable to authenticate phone number." };
//   }
// };

// export const verificationCall = async (phoneNumber) => {
//   const headers = {
//     UserId: "DTSUSER",
//     Password: "Dts@10099",
//     "Content-Type": "application/json",
//   };

  
//   const plainPhoneNumber = phoneNumber.replace("+", "");

//   const url = `attme/VerificationCall`;
//   const body = { MobileNumber: plainPhoneNumber };

//   try {
//     const response = await axios.post(url, body, { headers });
    
//     return response.data;
//   } catch (error) {
//     console.error("Error sending verification call:", error);
//     throw error.response
//       ? error.response.data
//       : { message: "Server Error. Unable to send verification call." };
//   }
// };



// export const fetchUserData = async (phoneNumber) => {
//   const headers = {
//       UserId: "DTSUSER",
//       Password: "Dts@10099",
//   };

//   // Clean the phone number
//   const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
  
//   // Create both formats
//   let withPlus = cleanNumber;
//   let withoutPlus = cleanNumber;

//   // Format the numbers correctly
//   if (cleanNumber.startsWith('94')) {
//       withPlus = `+${cleanNumber}`;
//       withoutPlus = cleanNumber;
//   } else if (cleanNumber.startsWith('+94')) {
//       withPlus = cleanNumber;
//       withoutPlus = cleanNumber.slice(1);
//   }

//   const tryFormat = async (number) => {
//       try {
//           headers.PhoneNo = number;
//           const response = await axios.get(
//               `attme/Login`,
//               { headers }
//           );
          
//           // Check both responceType and responceMessage
//           if (response?.data?.responceType === true && response?.data?.responceMessage) {
//               return {
//                   success: true,
//                   data: response.data,
//                   phoneFormat: number
//               };
//           }
//           return { success: false };
//       } catch (error) {
//           console.log(`Failed with format ${number}:`, error);
//           return { success: false };
//       }
//   };

//   try {
//       // Try both formats sequentially to ensure proper handling
//       const plusResult = await tryFormat(withPlus);
//       if (plusResult.success) {
//           return {
//               ...plusResult.data,
//               correctPhoneFormat: withPlus,
//               headers: { ...headers, PhoneNo: withPlus }
//           };
//       }

//       const noPlusResult = await tryFormat(withoutPlus);
//       if (noPlusResult.success) {
//           return {
//               ...noPlusResult.data,
//               correctPhoneFormat: withPlus, // Always store as +94 format
//               headers: { ...headers, PhoneNo: withPlus }
//           };
//       }

//       throw new Error("Neither phone format was accepted");
//   } catch (error) {
//       console.error("Error fetching user data:", error);
//       throw error.response
//           ? error.response.data
//           : { message: "Server Error. Unable to fetch user data." };
//   }
// };


